import { createReducer, on } from '@ngrx/store';
import { ProjectTemplate } from './models/project-template.model';
import {
  ProjectTemplatesLoadedAction,
  ProjectTemplatesErroredAction,
  ProjectTemplatesErrorTimedOutAction,
} from './project-template.actions';
import { DashboardOpenedAction } from '../dashboard/dashboard.actions';

export interface ProjectTemplateState {
  templates: ProjectTemplate[];
  apiError: boolean;
}

const initialState: ProjectTemplateState = {
  templates: null,
  apiError: false,
};

export const projectTemplateReducer = createReducer(
  initialState,
  on(DashboardOpenedAction, (state) => ({ ...state, templates: [], apiError: false })),
  on(ProjectTemplatesLoadedAction, (state, { templates }) => ({
    ...state,
    templates,
  })),
  on(ProjectTemplatesErroredAction, (state) => ({
    ...state,
    apiError: true,
  })),
  on(ProjectTemplatesErrorTimedOutAction, (state) => ({
    ...state,
    apiError: false,
  })),
);
